import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../../shared/hooks/useApi";
import type { CaregiverProfileCaregiver } from "../../../caregiverProfileModal.types";

export function useCaregiverProfileAvailability(caregiverId: CaregiverProfileCaregiver["id"]) {
  const { api } = useApi();

  return useQuery({
    queryKey: ["caregiverProfileModal", caregiverId, "availability"],
    queryFn: () =>
      api.get("/agencies/:agencyId/caregivers/:caregiverId/availability", {
        path: { caregiverId },
      }),
  });
}
